import { FieldProps, useFieldHelper } from 'framework/ui/field';
import useIsEmployeeProfileAccessible from '../permissions/useIsEmployeeProfileAccessible';
import EmployeeLinkFieldWithNameLoading from './EmployeeLinkFieldWithNameLoading';

const EmployeeLinkFieldWithAccessCheck = ({ source, externalId, value, ...props }: FieldProps) => {
  const { getValue } = useFieldHelper({ source });
  const alias = externalId || value || getValue();
  const isProfileAccessible = useIsEmployeeProfileAccessible(alias);

  return (
    <EmployeeLinkFieldWithNameLoading
      source={source}
      externalId={externalId}
      value={value}
      isLink={isProfileAccessible}
      {...props}
    />
  );
};

export default EmployeeLinkFieldWithAccessCheck;
